import "../../new.scss";
import { useParams, useNavigate } from 'react-router-dom';
import { useState, useContext, useEffect, useRef } from "react";
import { LocalidadesFormContext } from '../../../context/localidades/LocalidadesContext';
import ProvinciasModal from '../../provincias/provinciasModal/provinciasModal';
import DepartamentosModal from '../../departamentos/departamentosModal/departamentosModal';
import ConfirmationDialog from "../../../components/dialogs/ConfirmationDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDialog";
import FormField from "../../../components/FormField/FormField";
import FormButtons from "../../../components/FormButtons/FormButtons";
import Inputs from "./configForm/inputs";
import { handleInputChange } from "./helpersForm/formHandlers";

export const Form = ({ title }) => {
  const [form, setForm] = useState({});
  const { report, postLocalidadData, patchLocalidadData } = useContext(LocalidadesFormContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [searchFilter, setSearchFilter] = useState();
  const [searchDescFilter, setSearchDescFilter] = useState('');
  const [searchSecondFilter, setSearchSecondFilter] = useState();
  const [searchSecondDescFilter, setSearchSecondDescFilter] = useState('');

  const nameData = "localidades";
  const saveData = postLocalidadData;
  const updateData = patchLocalidadData;

  useEffect(() => {
    
    if (report && Object.keys(report).length > 0) {
      setForm((prevForm) => ({
        ...report,  // Copia todos los valores de report
        pcia_id: report.pcia_id || "",  // Asegura que ramo_Id esté seteado
      }));
      setSearchFilter(report.pcia_id);
      setSearchSecondFilter(report.depa_id);
      setSearchDescFilter(report.localidad_provincia?.pcia_descripcion || "");
      setSearchSecondDescFilter(report.localidad_departamento?.depa_descripcion || "");
      delete form.departamento
    }
  }, [report]);

  useEffect(() => {
    if(searchFilter ===null)
    {
      setSearchSecondFilter(""); // Limpia el filtro del departamento
      setSearchSecondDescFilter(""); // Limpia la descripción del departamento
      setForm((prevForm) => ({
        ...prevForm,
        pcia_id: null, // Borra departamento_Id en el formulario
        depa_id: null, // Borra departamento_Id en el formulario
      }));
    }
   
  }, [searchFilter, form.pcia_id]); // Dependemos de ambos para limpiar los valores
  useEffect(() => {
    setForm((prevForm) => ({
      ...prevForm,
      pcia_id: searchFilter // Borra departamento_Id en el formulario
    }));
  }, [searchFilter]);

  useEffect(() => {
    setForm((prevForm) => ({
      ...prevForm,
      depa_id: searchSecondFilter // Borra departamento_Id en el formulario
    }));
  }, [searchSecondFilter]);
  
  const handleChange = (e) => {
    handleInputChange(e, setForm, Inputs, setErrors, form);
  };

  const validateForm = () => {
    let formErrors = {};


    Inputs.forEach(({ name, validation }) => {
      if (validation) {
        const error = validation(form[name] || "", form);
        if (error) formErrors[name] = error;
      }
    });
    setErrors(formErrors);
    return !Object.keys(formErrors).length;
  };

  const openConfirmDialog = () => setIsConfirmDialogOpen(true);
  const closeConfirmDialog = () => setIsConfirmDialogOpen(false);

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };
  const closeErrorDialog = () => setIsErrorDialogOpen(false);


  // Enviar datos
  const handleSendData = () => {
    if (!validateForm()) {
      // Usamos un callback para asegurarnos de que `errors` esté actualizado
      setErrors((prevErrors) => {
        const errorMessagesArray = Inputs.reduce((acc, { name, label }) => {
          if (prevErrors[name]) {
            const fieldLabel = label || name; // Usar el label si existe, si no, usar el nombre del campo
            acc.push(`${fieldLabel}: ${prevErrors[name]}`);
          }
          return acc;
        }, []);

        // Solo abrimos el diálogo de error cuando se hayan generado los mensajes
        if (errorMessagesArray.length > 0) {
          openErrorDialog(errorMessagesArray);
        }

        return prevErrors; // No modificamos el estado aquí
      });

      return;
    }
    openConfirmDialog();
  };

  const confirmSendData = async () => {
    setIsSubmitting(true);
    closeConfirmDialog();

    const { pcia_id, ...formUpdated } = form;
    try {
      if (id) {
        await updateData(id, formUpdated);
      } else {
        await saveData(formUpdated);
      }
      navigate(`/${nameData}`);
    } catch (error) {
      console.error(error);
      openErrorDialog("Error al guardar los datos. Intenta nuevamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(`/${nameData}`);
  };
  return (
    <div className="new">
      <div className="newContainer">
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <form>
              {Inputs.map((input, index) => {
                const key = input.id ?? `${input.name}-${index}`;
                if (input.name === "pcia_id") {
                  return (
                    <div className="formInput" key={input.id || key} >
                      <label>{input.label}</label>
                      <ProvinciasModal
                        handleChange={setSearchFilter}
                        handleDescChange={setSearchDescFilter}
                        descSelected={searchDescFilter}
                      />
                      {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                    </div>
                  );
                } else if (input.name === "depa_id") {
                  if (searchFilter) {
                    return (
                      <div className="formInput" key={input.id || key} >
                        <label>{input.label}</label>
                        <DepartamentosModal
                          handleChange={setSearchSecondFilter}
                          handleDescChange={setSearchSecondDescFilter}
                          idSelectorProv={searchFilter}
                          descSelected={searchSecondDescFilter}
                        />
                        {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                      </div>
                    );
                  }
                  return null;
                } else {
                  return (
                    <FormField
                      key={input.id}
                      input={input}
                      value={form[input.name] || ""}
                      handleInputChange={(e) => handleChange(e)}
                      error={errors[input.name]}
                    />
                  );
                }
              })} </form>
              <FormButtons
                isSubmitting={isSubmitting}
                handleSave={handleSendData}
                handleCancel={handleCancel}
                saveText="Guardar"
                cancelText="Cancelar"
              />
            

            <ConfirmationDialog
              isOpen={isConfirmDialogOpen}
              onClose={closeConfirmDialog}
              onConfirm={confirmSendData}
              title=""
              message="¿Estás seguro de que deseas guardar este registro?"
            />
            <ErrorDialog
              isOpen={isErrorDialogOpen}
              onClose={closeErrorDialog}
              messages={errorMessage}
              title=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
